import { createEntityQueryKeys } from '@/shared/lib'

export const searchKeys = createEntityQueryKeys(['search'])
